import { colors } from '@plataforma/components';
import styled from 'styled-components';
import {
  RadioButton,
  Button as ButtonComponent,
  Select as SelectComponent
} from 'junto-ui';

export const Container = styled.div`
  width: 100%;
  display: flex;
`;

export const MainText = styled.div`
  font-family: Metropolis;
  font-style: normal;
  font-weight: 600;
  font-size: 38px;
  line-height: 44px;
  color: #180a33;
  margin-top: 112px;
`;

export const MiddleText = styled.div`
  color: #180a33;
  font-size: 20px;
  line-height: 26px;
  font-family: Metropolis;
  font-style: normal;
  font-weight: normal;
  padding-bottom: 8px;
`;

export const SmallerText = styled.div`
  color: #180a33;
  font-size: 16px;
  line-height: 26px;
  font-family: Metropolis;
  font-style: normal;
  font-weight: normal;
  padding-top: 32px;
`;

export const AlignItens = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 90px;
`;

export const StyledHeader = styled.header`
  flex: 0 0 auto;
  padding: 0px;
  display: flex;
  height: 88px;
  background-color: #fff;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 0 32px;
  align-self: stretch;
  left: 90%;
`;

export const StyledRadioButton = styled(RadioButton)`
  margin-top: 19px;
  pointer-events: ${({ disabled }) => disabled && 'none'};
  opacity: ${({ disabled }) => disabled && '0.4'};

  label {
    font-size: 16px;
    white-space: nowrap;
  }
`;

export const ExtractStepWrapper = styled.div`
  text-align: left;
  display: flex;
  max-width: 310px;
  pointer-events: ${({ disabled }) => disabled && 'none'};
  opacity: ${({ disabled }) => disabled && '0.4'};
  div {
    margin-right: 30px;
  }
`;

export const Button = styled(ButtonComponent)`
  width: 100%;
  margin-top: 24px;

  font-family: Metropolis;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #ffffff;
  text-align: center;
  color: #ffffff;
`;

export const SelectModality = styled(SelectComponent)`
  margin-top: 32px;
`;

export const SelectCoverage = styled(SelectComponent)`
  margin-top: 16px;
`;

export const ScrollbarParticularDetails = styled.div`
  height: 300px;
  overflow: auto;
  overflow-x: hidden;
`;

export const Tooltip = styled.div`
  background: ${({ color }) => color || colors.blueyGrey};
  margin-inline: auto;
  top: 4px;
  border-radius: 4px;
  font-size: 12px;
  color: black;
  text-align: center;
  vertical-align: middle;
  padding: 16px;
  opacity: 0;
  transform: scale(0.8);
  transition: all 0.2s ease;
  pointer-events: none;
  box-shadow: 0 0 1em #E0E7EC;
  border: 1px solid #E0E7EC;
  box-sizing: border-box;
  &:before {
    content: '';
    display: inline-block;
    vertical-align: bottom;
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid ${({ color }) => color || colors.blueyGrey};
    margin: 0;
    opacity: 0;
    position: absolute;
    transition: all 0.2s ease;
  }:after {
    content: '';
    position: absolute;
    bottom: -5px;
    display: block
    top: 48px;
    right: 42px;
    width: 13px;
    height: 13px;
    transform: rotate(45deg) translate(2px);
    border-right: 1px solid #E0E7EC;
    border-bottom: 1px solid #E0E7EC;
    background-color: white;
    color: #ffffff;
  }
`;

export const Wrapper = styled.div`
  background-color: ${colors.white};
  border-radius: 4px;
  box-sizing: border-box;
  width: 820px;
`;
export const Title = styled.h1`
  font-family: 'Metropolis-SemiBold', sans-serif;
  font-size: 20px;
  line-height: 26px;
  color: #180a33;
  align-self: flex-start;
`;

export const Subtitle = styled.h2`
  position: relative;
  width: 334px;
  height: 26px;
  left: 374px;
  padding-right: 1000px;
  top: calc(50% - 26px / 2 - 570px);
  font-family: Metropolis;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 26px;
  color: #180a33;
`;

export const Text = styled.p`
  position: relative;
  padding-right: 32px;
  padding-left: 0;
  text-decoration: none;
  margin-top: 24px;
  margin-left: 0;
  font-family: Metropolis;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: left;
`;

export const Emphasis = styled.strong`
  font-family: 'Metropolis-SemiBold', sans-serif;
`;

export const Ancora = styled.a`
  position: relative;
  padding-right: 32px;
  padding-left: auto;
  text-decoration: none;
  margin-top: 24px;
  color: #85909a;
  font-weight: 600;
  &:hover {
    color: #9000ff;
    text-decoration: underline;
  }
  cursor: pointer;
`;

export const ModalContainer = styled.div`
  margin: 64px;
`;

export const ConditionDetails = styled.div`
  height: 300px;
  overflow: auto;
  overflow-x: hidden;
  padding: 0 10px 0 10px;
`;

export const MenuWrapper = styled.div`
  position: sticky;
  align-self: center;
  top: 0;
  background-color: white;
  margin: auto;
  width: 100%;
`;
export const MenuItemsWrapper = styled.div`
  margin: 24px 0 24px 0;
`;

export const ContentWrapper = styled.div`
  min-height: 300px;
  height: 100%;
  align-self: baseline;
  width: 100%;
`;

export const ParticularDetails = styled.div`
  margin: 12px 0 12px 0;
  font-family: Metropolis;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  color: #180a33;
  width: 640px;
`;

export const GrayBorder = styled.div`
  border-bottom: 1px solid #e0e7ec;
`;

export const ContentContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: left;
  font-size: 16px;
  color: ${colors.bluishGrey};
  line-height: 24px;
`;
export const LinkImage = styled.div`
  display: flex;
  flex-direction: column-reverse;
  width: 100px;
  height: 30px;
  justify-self: end;
  cursor: pointer;
  &:hover {
    ${Tooltip} {
      opacity: 1;
      transform: scale(1);
      top: -15px;

      &:before {
        opacity: 1;
        margin: 20px 0 0 -5px;
      }
    }
  }
`;

export const AlignItensParticular = styled.div`
  display: grid;
  grid-template-rows: 39px;
  grid-template-columns: 1fr 1fr;
`;

export const Image = styled.img`
  margin-inline: auto;
  padding: 16px 30px 0 0;
`;

export const TooltipWrapper = styled.div``;

export const ButtonWrapper = styled.div`
  width: 100%;
  align-self: center;
  background-color: white;
`;
